module.exports = __webpack_public_path__ + "img/11_L2.17f129b0.svg";